import { FormBaseType } from "@green0meter/api-client";

import { REPORT_PAGES } from "@constants";

export const CSRD_CONFIG = {
  formBaseType: FormBaseType.ESRS,
  welcomeBanner: {
    titleKey: "csrdhub.welcome",
    textKey: "csrdhub.welcomeText",
    color: "blue",
    icon: "accountant",
  },
  collectData: {
    titleKey: "csrdCollectionDataTitle",
    descriptionKey: "csrdCollectionDataDescription",
    color: "teal",
    icon: "data-gathering",
    buttonTextKey: "csrdCollectionDataButtonStart",
    noFormsTextKey: "collectData.noFormsCreated",
  },
  reports: {
    titleKey: "csrd.hub.reports.title",
    type: "csrd-reports",
    noReportsTextKey: "csrd.hub.reports.noReports",
    fillFormTextKey: "csrd.hub.reports.fillForm",
  },
  overview: {
    titleKey: "csrd.hub.overview.title",
    dashboardPath: "/csrd/dashboard",
    viewDashboardTextKey: "common.viewDashboard",
    reportPageId: REPORT_PAGES.ESRS,
  },
};
